export enum DeltaDirections {
    UP = "up",
    DOWN = "down",
    INITIAL = "initial",
}
